import * as React from 'react'
import styled from 'styled-components'

import SocialButton, { SOCIAL_TYPE } from './SocialButton'

// ========================== Styled components ================================

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: flex-start;
  margin-top: 15px;
`

// ================================ Types ======================================

type SocialContainerProps = {
  address: string
  youtubeHandle?: string
  twitterHandle?: string
  instagramHandle?: string
}

// ========================== React component ==================================

const SocialContainer = ({
  address,
  youtubeHandle,
  twitterHandle,
  instagramHandle,
}: SocialContainerProps): JSX.Element => {
  return (
    <Container>
      <SocialButton type={SOCIAL_TYPE.ID} handle={address} />
      <SocialButton type={SOCIAL_TYPE.YOUTUBE} handle={youtubeHandle} />
      <SocialButton type={SOCIAL_TYPE.TWITTER} handle={twitterHandle} />
      <SocialButton type={SOCIAL_TYPE.INSTAGRAM} handle={instagramHandle} />
    </Container>
  )
}

export default SocialContainer
